const { City, Street, Building, BuildingPart } = require('./address')
const { translate } = require('./locale')

async function addressToStr(address, lang = 'ru') {
    if(!address || (typeof address === 'object' && !Object.keys(address).length)) return ''
    let str = ''
    let {
        country = '',
        region,
        locality,
        locality_id,
        street,
        building,
        buildingNumber,
        building_number,
        apartment_id,
        buildingPart,
        apartment,
        extra = '',
    } = address

    locality_id = locality_id || locality
    building = building || building_number || buildingNumber
    apartment_id = apartment_id || buildingPart || apartment
    
    if(!locality_id || !street || !building) return ''
    
    locality = await City.getById(locality_id)
    if(!locality) return ''
    locality = `${locality.parent ? `${locality.parent_title} ${locality.parent}, ` : ''}${locality.title} ${locality.name_rus}`
    
    street = await Street.getById(street)
    if(!street) return ''
    street = `${street.title} ${street.name_rus}`
    
    building = await Building.getById(building)
    if(!building) return ''
    buildingNumber = `${building.title} ${building.number}`

    if(hasAddressPart(apartment_id)) {
        apartment_id = await BuildingPart.getById(apartment_id)
        if(!apartment_id) return ''
        apartment = `${apartment_id.title} ${apartment_id.number}`
    } else {
        apartment = ''
    }

    str = [country, region, locality, street, buildingNumber, apartment, extra]
        .filter(Boolean)
        .join(', ')

    return clearDublicateLocalities(str)
}

function hasAddressPart(value) {
    if(value == null) return false

    const normalized = String(value).trim().toLowerCase()

    return normalized !== '' && normalized !== '0' && normalized !== 'null'
}

async function addressToStrObject(addressId, lang = 'ru') {
    let mainTable = 'rka_addresses'

    let q = await db.selectOne(mainTable, { filter: { id: addressId } })

    let region = await getRegionName(q.locality_id)

    let city = await getCityName(q.locality_id)

    let street = await getStreetName(q.street)

    let building = await getBuildingName(q.building_number)

    let buildingPart

    if(q.apartment) {
        buildingPart = await getBuildingPartName(q.apartment)
    } 
    else {
        buildingPart = ''
    }

    let zipCode = await getZipcodeByRkaAddress(addressId)

    return {
        region: region,
        city: city,
        street: street,
        building: building,
        buildingPart: buildingPart,
        zipCode: zipCode
    }
}

async function getAddressExtra(addressId, recipientId) {
    if (!addressId || !recipientId) return null

    let ra = await db.selectOne('recipients_addresses', { filter: { address_id: addressId, recipient_id: recipientId }})

    return ra ? ra.extra : null
}

async function getZipcodeByRkaAddress(addressId) {
    let mainTable = 'rka_addresses'
    
    let rkaAddress = await db.selectOne(mainTable, { filter: { id: addressId } })

    let q = await db.selectOne('rka_ats', { filter: { id: rkaAddress.locality_id } })

    let locality = await getLocalityByKato(q.cato)

    let zipCode = await getNearestZipcode(locality.id)

    return zipCode
}

async function getRegionName(id, lang = 'ru') {
    let table = 'rka_ats'
    let typesTable = "rka_types"

    let city = await db.selectOne(table, { filter: { id: id } })
    let tempCity = city
    let savedCity = {}

    while(tempCity && tempCity?.ats_type != 7) {
        tempCity = await db.selectOne(table, { filter: { id: tempCity.parent_id } })
        if(!tempCity || tempCity == '') {
            break
        }
        savedCity = tempCity
    }
    city = savedCity

    let cityPrefix = await db.selectOne(typesTable, { filter: { type_id: 7, table_name: 'ats' } })

    let cityName = cityPrefix.title + " "

    if(lang == 'ru') {
        cityName += city.name_rus
    }
    else {
        cityName += city.name_kaz
    }
    
    return cityName
}

async function getCityName(id, lang = 'ru') {
    let table = 'rka_ats'
    let typesTable = "rka_types"

    let city = await db.selectOne(table, { filter: { id: id } })
    let cityPrefix = await db.selectOne(typesTable, { filter: { type_id: city.ats_type, table_name: 'ats' } })

    let cityName = cityPrefix.title + " "

    if(lang == 'ru') {
        cityName += city.name_rus
    }
    else {
        cityName += city.name_kaz
    }
    
    return cityName
}

async function getStreetName(id, lang = 'ru') {
    let table = 'rka_geonims'
    let typesTable = "rka_types"

    let street = await db.selectOne(table, { filter: { id: id } })
    let streetPrefix = await db.selectOne(typesTable, { filter: { type_id: street.geonim_type, table_name: 'geonims' } })

    let streetName = streetPrefix.title + " "

    if(lang == 'ru') {
        streetName += street.name_rus
    }
    else {
        streetName += street.name_kaz
    }
    
    return streetName
}

async function getBuildingName(id) {
    let table = 'rka_buildings'
    let typesTable = "rka_types"

    let building = await db.selectOne(table, { filter: { id: id } })
    let buildingPrefix = await db.selectOne(typesTable, { filter: { type_id: building.d_buildings_pointer_id, table_name: 'buildings' } })

    let buildingName = buildingPrefix.title + " "

    buildingName += building.number
    
    return buildingName
}

async function getBuildingPartName(id) {
    let table = 'rka_building_parts'
    let typesTable = "rka_types"
    
    let buildingPart = await db.selectOne(table, { filter: { id: id } })
    let buildingPartPrefix = await db.selectOne(typesTable, { filter: { type_id: buildingPart.room_type, table_name: 'building_parts' } })

    let buildingPartName = buildingPartPrefix.title + " "

    buildingPartName += buildingPart.number
    
    return buildingPartName
}

function shortAddress(address) {
    let str = ''
    let {
        street,
        buildingNumber,
        apartment,
        extra = ''
    } = address

    let arr = Object.values(address)

    if(street) str += street
    if(buildingNumber) str += ', ' + buildingNumber
    if(apartment) str += ', ' + apartment
    if(extra) str += ', ' + extra

    str = arr.join(', ')

    return clearDublicateLocalities(str)
}

function clearDublicateLocalities(str) {
    const arr = str.split(', ')
    return arr.filter((value, index) => arr.indexOf(value) === index).join(', ')
}

async function getFromDB(item, table) {
    let q = await db.selectOne(table, { filter: { id: item } })

    if(q) return q.title
    return item
}

async function getZipcode(localityId) {
    const t = 'localities'
    let locality = await db.selectOne(t, {
        filter: { id: localityId }
    })

    if(locality && locality.zip_code) return locality.zip_code
    return null
}

async function getNearestZipcode(localityId) {
    const locality = await db.selectOne('localities', {
        filter: { id: localityId }
    })

    if(!locality) return null

    if(locality.zip_code) return locality.zip_code

    // const [relationsResult] = await db.execute(
    //     `SELECT l.zip_code
    //         FROM localities l
    //         WHERE 
    //         (l.parent_id = ? OR l.id = ? OR EXISTS (
    //             SELECT 1 
    //             FROM localities sub_l 
    //             WHERE sub_l.parent_id = l.id AND sub_l.id = ?
    //         ))
    //         AND COALESCE(l.zip_code, '') <> ''
    //         LIMIT 1`,
    //     [localityId, localityId, localityId]
    // )

    // if(relationsResult.zip_code) return relationsResult.zip_code

    let zip = await findZipCodeForLocality(localityId)
    if(zip) return zip

    const [regionResult] = await db.execute(
        `SELECT zip_code
            FROM localities
            WHERE region_id = ? AND zip_code != ''
            LIMIT 1`,
        [locality.region_id]
    )

    if(regionResult.zip_code) return regionResult.zip_code

    return null
}

async function findZipCodeForLocality(localityId) {
    let zip = ''
    let locality = await db.selectOne('localities', { filter: { id: localityId } })
    if(locality.zip_code) {
        zip = locality.zip_code
        return zip
    } else {
        if(locality.parent_id) {
            await findZipCodeForLocality(locality.parent_id)
        } else {
            return false
        }
    }
}

async function checkLocalityByKato(locality) {
    if(!locality) return false

    let q = await db.selectOne('localities', { filter: { kato_code: locality } })

    return q?.id || false
}

async function addRecipientAddress(recipientId, addressId) {
    let t = 'recipients_addresses'

    let check = await db.selectOne(t, { filter: { recipient_id: recipientId, address_id: addressId } })

    if(check) return check.id
    
    let q = await db.insert(t, { recipient_id: recipientId, address_id: addressId })

    return q || false
}

async function getLocality(id) {
    let q = await db.selectOne('localities', { filter: { id: id } })
    return q
}

async function getLocalityByKato(kato) {
    let q = await db.selectOne('localities', { filter: { kato_code: kato } })
    return q
}

async function localityPath(localityId) {
    let locality = await getLocality(localityId)
    if(!locality) return ''

    if(locality.parent_id) {
        let parentPath = await localityPath(locality.parent_id)
        if(!parentPath) return locality.title

        return `${parentPath}, ${locality.title}`
    } else {
        return locality.title
    }
}

async function fullLocalityPath(localityId) {
    let locality = await getLocality(localityId)
    if(!locality) return ''
    let region = ''
    let country = ''

    if(!isNaN(locality.region_id)) region = await db.selectOne('regions', { filter: { id: locality.region_id } })
    if(region && !isNaN(region.country_id)) country = await db.selectOne('countries', { filter: { id: region.country_id } })

    let _localityPath = await localityPath(localityId)

    if(region) _localityPath = `${region.title}, ${_localityPath}`
    if(region && country) _localityPath = `${country.title}, ${_localityPath}`

    return _localityPath
}

/**
 * 
 * @param {int} localityId - id населенного пункта
 * @returns localityId
 * меняет localityId н.п. если это район города на localityId города
 * для привязывания улиц к городам а не районам городов
 */
async function getTrueLocalityId(localityId) {
    if(!localityId || isNaN(localityId)) return false
    
    let locality = await db.query(`SELECT l.*, lp.id AS p_id, lp.region_id AS p_region_id, lp.title AS p_title, lp.zip_code AS p_zip_code, lp.type_id AS p_type_id, lp.kato_code AS p_kato_code, lp.parent_id AS p_parent_id FROM localities l, localities lp WHERE l.id = ${localityId} AND l.parent_id = lp.id`)

    if(locality[0]) {
        if(locality[0].title.includes('район ') && (locality[0].p_title.includes('с. ') || locality[0].p_title.includes('г. '))) localityId = locality[0].p_id
    }
    
    return localityId
}

async function getLocalityCountry(localityId) {
    if(!localityId || isNaN(localityId)) return ''

    let [ country ] = await db.query(`SELECT c.* FROM countries c JOIN regions r ON r.country_id = c.id JOIN localities l ON l.region_id = r.id WHERE l.id = ${localityId}`)

    if(!country) return ''

    return country.title
}

async function getLocalityRegion(localityId) {
    if(!localityId || isNaN(localityId)) return ''

    let [ region ] = await db.query(`SELECT r.* FROM regions r JOIN localities l ON l.region_id = r.id WHERE l.id = ${localityId}`)

    if(!region) return ''

    return region.title
}

module.exports = {
    addressToStr,
    shortAddress,
    getFromDB,
    getNearestZipcode,
    getZipcode,
    checkLocalityByKato,
    addRecipientAddress,
    localityPath,
    fullLocalityPath,
    getTrueLocalityId,
    getLocalityCountry,
    getLocalityRegion,
    addressToStrObject,
    getLocalityByKato,
    getAddressExtra,
}
